import React from 'react';
import { MAP_STYLES } from '../constants/mapStyles';
import './MapStyleSelector.css';

/**
 * Compact floating base-map style switcher.
 * Designed to sit inside a map wrapper with position: relative.
 */
function MapStyleSelector({ active, onChange }) {
  return (
    <div className="map-style-selector" role="group" aria-label="Map style">
      {MAP_STYLES.map(({ key, label }) => (
        <button
          key={key}
          className={`map-style-btn ${active === key ? 'active' : ''}`}
          onClick={() => onChange(key)}
          aria-pressed={active === key}
          type="button"
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default MapStyleSelector;
